// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"styles_widgetContainer__370H3","imageContainer":"styles_imageContainer__1X29W","widgetImage":"styles_widgetImage__qrqSC","title":"styles_title__1t6z5"};